var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.63438 1 1.5 4.13438 1.5 8C1.5 11.8656 4.63438 15 8.5 15C12.3656 15 15.5 11.8656 15.5 8C15.5 4.13438 12.3656 1 8.5 1ZM11.5234 5.71406L8.23281 10.2766C8.18682 10.3408 8.12619 10.3931 8.05595 10.4291C7.98571 10.4652 7.90787 10.4841 7.82891 10.4841C7.74994 10.4841 7.67211 10.4652 7.60186 10.4291C7.53162 10.3931 7.47099 10.3408 7.425 10.2766L5.47656 7.57656C5.41719 7.49375 5.47656 7.37813 5.57812 7.37813H6.31094C6.47031 7.37813 6.62187 7.45469 6.71562 7.58594L7.82812 9.12969L10.2844 5.72344C10.3781 5.59375 10.5281 5.51562 10.6891 5.51562H11.4219C11.5234 5.51562 11.5828 5.63125 11.5234 5.71406V5.71406Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/CheckCircleFilled.c0a437f31f43211a2c098da894f72c29.svg";
export { ForwardRef as ReactComponent };